


export function heightAuto(el) {
    var sectionHeight = el.scrollHeight;
    if(el.style.height != 'auto'){
        el.style.height = sectionHeight + "px";
        function afterTransition() {
            el.style.height = 'auto';
            el.removeEventListener("transitionend", afterTransition);
        }
        el.addEventListener("transitionend", afterTransition);
    }
}

export function height0(el) {
    var sectionHeight = el.scrollHeight;
    el.style.height = sectionHeight + "px";
    requestAnimationFrame(function() {
        el.style.height = 0 + "px";
    });
}
